import React from 'react'
import { InfoItem, InfoTitle, InfoValue, MainInfoContainer } from './styled'

interface Props {
  coverInformation: { label: string; value: string; color?: string }[]
}
export const CoverInformation: React.FC<Props> = ({ coverInformation }) => {
  return (
    <MainInfoContainer>
      {coverInformation.map(({ label, value, color }) => (
        <InfoItem key={label}>
          <InfoTitle>{label}</InfoTitle>
          {color ? <InfoValue color={color}>{value}</InfoValue> : <InfoValue>{value}</InfoValue>}
        </InfoItem>
      ))}
    </MainInfoContainer>
  )
}
